import React from 'react';
import TradeTermsTable from '../components/TradeTermTable';

export function TradeTerms() {
  return <TradeTermsTable />;
}
